"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colours = exports.Colour = void 0;
var Colour;
(function (Colour) {
    Colour["Primary"] = "#4C30FB";
    Colour["DarkBlue"] = "#113148";
    Colour["White"] = "#FFFFFF";
    Colour["LightBlue"] = "#94B8D2";
    Colour["Black"] = "#000000";
    // Text (WIP)
    Colour["TextPrimary"] = "#2E3338";
    Colour["TextSecondary"] = "#555E66";
    Colour["TextTertiary"] = "#68727A";
    Colour["TextLink"] = "#3B25C4";
    Colour["TextDestructive"] = "#BF332E";
    Colour["TextReversed"] = "#FFFFFF";
    // Icon (WIP)
    Colour["IconAction"] = "#3B25C4";
    Colour["IconPrimary"] = "#2E3338";
    Colour["IconSecondary"] = "#68727A";
    Colour["IconDestructive"] = "#BF332E";
    Colour["IconReversed"] = "#FFFFFF";
    // Other
    Colour["PageBackgroundPrimary"] = "#FFFFFF";
    Colour["PageBackgroundSecondary"] = "#F5F6F7";
    Colour["SeparatorMinimal"] = "#E9ECF0";
    Colour["SeparatorBold"] = "#A0A9B0";
    Colour["RejectButton"] = "#B34247";
    // Red
    Colour["Red5"] = "#F9EEEE";
    Colour["Red10"] = "#F8E1DE";
    Colour["Red30"] = "#F2938C";
    Colour["Red40"] = "#E9695F";
    Colour["Red50"] = "#BF332E";
    Colour["Red60"] = "#A23737";
    // Orange
    Colour["Orange5"] = "#FEF2E4";
    Colour["Orange10"] = "#FCE2C5";
    Colour["Orange30"] = "#F09860";
    Colour["Orange40"] = "#E66F0E";
    Colour["Orange60"] = "#8C471C";
    // Yellow
    Colour["Yellow5"] = "#FFF5C2";
    Colour["Yellow10"] = "#FEE685";
    Colour["Yellow20"] = "#FACE00";
    Colour["Yellow30"] = "#DDAA01";
    Colour["Yellow60"] = "#776017";
    // Green
    Colour["Green5"] = "#DBF6ED";
    Colour["Green10"] = "#C7EFE2";
    Colour["Green40"] = "#34A37E";
    Colour["Green50"] = "#2E8367";
    Colour["Green60"] = "#286846";
    // Cyan
    Colour["Cyan5"] = "#E7F6F8";
    Colour["Cyan10"] = "#CCF2F1";
    Colour["Cyan30"] = "#5DD1CF";
    Colour["Cyan40"] = "#44ACAC";
    Colour["Cyan60"] = "#2A6D6C";
    // Blue
    Colour["Blue5"] = "#E8F5FF";
    Colour["Blue10"] = "#D4E5FF";
    Colour["Blue30"] = "#81AEFC";
    Colour["Blue40"] = "#5994f6";
    Colour["Blue60"] = "#0050D8";
    // Purple
    Colour["Purple5"] = "#F4F2FF";
    Colour["Purple10"] = "#E2DEFF";
    Colour["Purple30"] = "#B5A8FF";
    Colour["Purple60"] = "#3B25C4";
    Colour["Purple80"] = "#2A2163";
    // Grey
    Colour["Grey2"] = "#F9FAFB";
    Colour["Grey3"] = "#F5F6F7";
    Colour["Grey5"] = "#E9ECF0";
    Colour["Grey10"] = "#DADFE3";
    Colour["Grey20"] = "#C2C9CF";
    Colour["Grey30"] = "#A0A9B0";
    Colour["Grey50"] = "#68727A";
    Colour["Grey70"] = "#3D4852";
    Colour["Grey80"] = "#1F272E";
    Colour["Grey90"] = "#12191F";
})(Colour = exports.Colour || (exports.Colour = {}));
var brandColours = {
    red: {
        5: Colour.Red5,
        10: Colour.Red10,
        30: Colour.Red30,
        40: Colour.Red40,
        50: Colour.Red50,
        60: Colour.Red60,
    },
    orange: {
        5: Colour.Orange5,
        10: Colour.Orange10,
        30: Colour.Orange30,
        40: Colour.Orange40,
        60: Colour.Orange60,
    },
    yellow: {
        5: Colour.Yellow5,
        10: Colour.Yellow10,
        20: Colour.Yellow20,
        30: Colour.Yellow30,
        60: Colour.Yellow60,
    },
    green: {
        5: Colour.Green5,
        10: Colour.Green10,
        40: Colour.Green40,
        50: Colour.Green50,
        60: Colour.Green60,
    },
    cyan: {
        5: Colour.Cyan5,
        10: Colour.Cyan10,
        30: Colour.Cyan30,
        40: Colour.Cyan40,
        60: Colour.Cyan60,
    },
    blue: {
        5: Colour.Blue5,
        10: Colour.Blue10,
        30: Colour.Blue30,
        40: Colour.Blue40,
        60: Colour.Blue60,
    },
    purple: {
        5: Colour.Purple5,
        10: Colour.Purple10,
        30: Colour.Purple30,
        60: Colour.Purple60,
        80: Colour.Purple80,
    },
    grey: {
        2: Colour.Grey2,
        3: Colour.Grey3,
        5: Colour.Grey5,
        10: Colour.Grey10,
        20: Colour.Grey20,
        30: Colour.Grey30,
        50: Colour.Grey50,
        70: Colour.Grey70,
        80: Colour.Grey80,
        90: Colour.Grey90,
    },
};
var solidColours = {
    white: Colour.White,
    darkBlue: Colour.DarkBlue,
    lightBlue: Colour.LightBlue,
    black: Colour.Black,
};
var themedColours = {
    primary: Colour.Primary,
    textPrimary: Colour.TextPrimary,
    textSecondary: Colour.TextSecondary,
    textTertiary: Colour.TextTertiary,
    textLink: Colour.TextLink,
    textDestructive: Colour.TextDestructive,
    textReversed: Colour.TextReversed,
    iconAction: Colour.IconAction,
    iconPrimary: Colour.IconPrimary,
    iconSecondary: Colour.IconSecondary,
    iconDestructive: Colour.IconDestructive,
    iconReversed: Colour.IconReversed,
    pageBackgroundPrimary: Colour.PageBackgroundPrimary,
    pageBackgroundSecondary: Colour.PageBackgroundSecondary,
    separatorMinimal: Colour.SeparatorMinimal,
    separatorBold: Colour.SeparatorBold,
};
exports.colours = __assign(__assign(__assign({}, brandColours), solidColours), themedColours);
